import React, { useState } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
// @ts-ignore
import StylePropType from 'react-style-proptype';
import Tooltip from './Tooltip';
import { ocean, sky } from './colors';
const CopyText = (props) => {
    const { value, successMessage, onClick, hoverText, duration, style, className } = props;
    const [copied, setCopied] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const clickHandler = (e) => {
        var _a;
        copy(value || ((_a = props.children) === null || _a === void 0 ? void 0 : _a.toString()) || '');
        setCopied(true);
        setTimeout(() => setCopied(false), duration || 1500);
        if (onClick) {
            onClick(e);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { direction: 'top', contents: copied ? successMessage
                : (isHovered ? hoverText || 'Click To Copy' : ''), show: isHovered || copied },
            React.createElement("button", { className: className, onClick: clickHandler, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), style: Object.assign({ backgroundColor: sky.base, color: ocean.base, border: 'none', padding: 0 }, style), tabIndex: 0, "aria-label": (props.children || value) + '. ' + (hoverText || 'Click to Copy') },
                props.children || value,
                " ",
                React.createElement("i", { className: 'fa fa-copy', "aria-hidden": true })))));
};
CopyText.propTypes = {
    value: PropTypes.string,
    successMessage: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    hoverText: PropTypes.string,
    duration: PropTypes.number,
    style: StylePropType,
};
CopyText.defaultProps = {
    successMessage: 'Copied successfully.',
};
export default CopyText;
